// extracted by mini-css-extract-plugin
export default {"container":"_5072e332","searchTerm":"_a872c5d5"};